const KEY = "kc_recently_viewed";
const MAX = 12;

export const getRecentlyViewed = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
};

export const addRecentlyViewed = (p) => {
  if (!p?.slug) return;
  const slim = {
    slug: p.slug,
    title: p.title,
    price: p.price,
    compare_at: p.compare_at,
    discount_pct: p.discount_pct,
    images: (p.images || []).slice(0, 2),
    sizes: p.sizes || [],
    colors: p.colors || [],
    badge: p.badge,
    reviews_count: p.reviews_count || 0,
    stock_left: p.stock_left ?? null,
  };
  const list = getRecentlyViewed().filter((x) => x.slug !== p.slug);
  list.unshift(slim);
  try {
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch {
    /* ignore quota errors */
  }
};
